import {
    STORE_TRACKER_ACCOUNTS,
    STORE_TRACKER_ACCOUNT,
    MARK_TRACKER_ACCOUNT_CANCELLED,
    REMOVE_TRACKER_ACCOUNT,
} from '../../constants/businessTracker';

const initialState = {
    accounts: [],
    loaded: false,
};

const upsert = (accounts, account) => {
    const idx = accounts.findIndex((a) => a.accountId === account.accountId);
    if (idx === -1) return [...accounts, account];
    const next = accounts.slice();
    next[idx] = account;
    return next;
};

export default (state = initialState, action) => {
    switch (action.type) {
        case STORE_TRACKER_ACCOUNTS:
            return {
                ...state,
                accounts: action.accounts || [],
                loaded: true,
            };
        case STORE_TRACKER_ACCOUNT:
            return {
                ...state,
                accounts: upsert(state.accounts, action.account),
            };
        case MARK_TRACKER_ACCOUNT_CANCELLED:
            // Reversible Cancel: keep the row in the list but flip it to
            // 'cancelled' so it shows the Cancelled pill and can be
            // reactivated, instead of disappearing from view.
            return {
                ...state,
                accounts: state.accounts.map((a) =>
                    a.accountId === action.accountId
                        ? { ...a, status: 'cancelled' }
                        : a,
                ),
            };
        case REMOVE_TRACKER_ACCOUNT:
            // Soft-delete: the server retains the row (status='deleted') for
            // audit, but it's gone from every list response — so drop it from
            // client state too and it vanishes from the UI.
            return {
                ...state,
                accounts: state.accounts.filter(
                    (a) => a.accountId !== action.accountId,
                ),
            };
        default:
            return state;
    }
};
